import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import Transaction, {
  Load_Transaction,
  Validate_BillType,
} from "../Transaction/Transaction";
import { API_POST } from "../General/Utility";
import {
  Clear_Transaction,
  ShowHide_Popup,
} from "../features/Transactionstates";
function PurchaseEstimate() {
  //#region  Transaction Parems
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _Common = useSelector((store) => store.Transstates.Common);
  const _HT = useSelector((store) => store.Transstates.Header);
  const _DT = useSelector((store) => store.Transstates.Data);
  const _Sum = useSelector((store) => store.Transstates.Summary);
  const _Disc = useSelector((store) => store.Transstates.Discount);

  const _iScrId = 78;

  useEffect(() => {
    Load_Transaction(dispatch, _Common, _iScrId);
  }, []);

  const SaveClick = async () => {
    if (Number(_HT.iBillTypeId) === 0) {
      Show_Message(dispatch, "Bill Type is Required", "error");
    } else if (_DT.arrEntDT.length === 0) {
      Show_Message(dispatch, "Atleast One Item is Required", "error");
    } else {
      const PuResListHT = {
        iPurESId: Number(_HT.iVouchId),
        iBranchId: Number(_AuthParems.Branch),
        iTitleTag: Number(_Common.iScrId),        // ✅ Fix
        iPartyId: Number(_HT.iPartyId),           // ✅ Fix
        iNumSeqNo: Number(_HT.iNumSeqNo),
        strPrefix: _HT.strPrefix,
        strCompCode: _HT.strCompCode,
        strFinanFrom: _HT.strFinanFrom,
        strTransNo: _HT.strTransNo,
        strVouchNo: _HT.strVouchNo,
        strVouchDate: _HT.strVouchDate,
        iAddLessBillDiscId: Number(_HT.iALBillDiscId) || 0,  // ✅
        iBillTypeId: Number(_HT.iBillTypeId) || 0,    // ✅
        iTaxCalcOnId: Number(_HT.iTaxCalcOnId) || 0,   // ✅         // ✅ Fix
        iTaxTypeId: Number(_HT.iTaxRelId),               // ✅ Fix
        iDMId: Number(_HT.iDMId),
        strConvertDCVouch: _HT.strConvertDCVouch,
        strPartyDCVouch: _HT.strPartyDCVouch,
        strRefNum1: _HT.strRefNum1,
        dpRefNum1Date: _HT.dpRefNum1Date,
        strRefNum2: _HT.strRefNum2,
        dpRefNum2Date: _HT.dpRefNum2Date,
        strRefNum3: _HT.strRefNum3,
        dpRefNum3Date: _HT.dpRefNum3Date,
        strRefNum4: _HT.strRefNum4,
        dpRefNum4Date: _HT.dpRefNum4Date,
        strRemark1: _HT.strRemark1,
        strRemark2: _HT.strRemark2,
        strRemark3: _HT.strRemark3,
        strRemark4: _HT.strRemark4,
        strValidity: _HT.strValidity,
        dpValDateUpto: _HT.dpValDateUpto,
        strPayTerm: _HT.strPayTerm,
        dpPayTermDateUpto: _HT.dpPayTermDateUpto,
        strDeliTerm: _HT.strDeliTerm,
        dpDelTermDateUpto: _HT.dpDelTermDateUpto,
        strEComGstNo: _HT.strEComGstNo,
        strTransport: _HT.strTransport,
        strVehicle: _HT.strVehicle,
        strDespatch: _HT.strDespatch,
        dpDespatchDate: _HT.dpDespatchDate,
        strLRNNumber: _HT.strLRNNumber,
        dpLRNoDate: _HT.dpLRNoDate,
        strAgent: _HT.strAgent,
        strReference: _HT.strReference,
        strDestination: _HT.strDestination,
        dTBillDiscPer: Number(_Disc.dBillDisPer) || 0,
        dTBillDiscAmt: Number(_Disc.dBillDisAmt) || 0,
        dTBillDiscValue: Number(_Disc.dBillDisValue) || 0,
        dTAddLessDiscPer: Number(_Disc.dALBillDisPer) || 0,
        dTAddLessDiscAmt: Number(_Disc.dALBillDisAmt) || 0,
        dTAddLessDiscValue: Number(_Disc.dALBillDisValue) || 0,

        dTotQty: Number(_Sum.Qty) || 0,
        dTotGoodval: Number(_Sum.GoodsValue) || 0,
        dTotDiscount: Number(_Sum.TotalDiscount) || 0,  // ✅ Fix
        dTotTax: Number(_Sum.TotalTax) || 0,       // ✅ Fix
        dAddLess: Number(_Sum.TotalAddLess) || 0,   // ✅ Fix
        dTotTCSTax: Number(_Sum.TotalTCSTax) || 0,   // ✅ Fix
        dRoundOff: Number(_Sum.RoundOff) || 0,
        dNetAmt: Number(_Sum.NetAmt) || 0,
      };
      const res = await API_POST(
        "PurchaseEstimate/InsUpd_PurchaseEstimate/",
        {
          objEntSI: PuResListHT,
          objBaseTransDT: _DT.arrEntDT,
          objEntALDT: _DT.arrEntAL,
          objEntTax: _DT.arrEntTax,
          iUserId: Number(_AuthParems.User),
          FYid: Number(_AuthParems.Year),
          strDBName: _AuthParems.DB,
        },
        dispatch
      );
      if (res) {
        Show_Message(dispatch, res.strMessage, "success");
        if (
          _Common.EnableReceipt &&
          Number(_HT.iVouchId) === 0 &&
          (await Validate_BillType(_HT))
        ) {
          await dispatch(ShowHide_Popup("IsPayment"));
        } else Clear_Click();
      }
    }
  };
  const Clear_Click = async () => {
    try {
      await Pre_Loading(dispatch, true);
      await dispatch(Clear_Transaction());
      await Load_Transaction(dispatch, _Common, _Common.iScrId);
    } catch (e) {
      await Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };
  return <Transaction Save={SaveClick} ScrId={_iScrId} />;
}
export default PurchaseEstimate;
